import { getImageAttrs } from '~/modules/images';
import { ReactComponent as TriangleIcon } from '../images/author-rail-triangle.svg';
import { REVAMP_AVATAR_WIDTH } from '../util/revamp-image-sizes';

export interface RevampAuthor {
    name: string;
    org?: string;
    avatarUrl?: string;
}

/**
 * Vertical "Written by" author rail pinned to the page's top left (Figma
 * 2471:69011): round avatar, triangle marker, then the author name and label
 * reading bottom-to-top. Desktop only — mobile keeps the header byline.
 */
export const RevampAuthorRail = ({ name, org, avatarUrl }: RevampAuthor) => {
    const displayName = org ? `${name}, ${org}` : name;

    return (
        <aside className="absolute top-[34.7rem] left-[1.0625rem] hidden w-16 flex-col items-center gap-5 md:flex">
            {avatarUrl && (
                // Decorative: the author's name is spelled out right below it.
                <img
                    {...getImageAttrs(avatarUrl, {
                        width: REVAMP_AVATAR_WIDTH,
                    })}
                    alt=""
                    width={REVAMP_AVATAR_WIDTH}
                    height={REVAMP_AVATAR_WIDTH}
                    decoding="async"
                    className="size-16 rounded-full object-cover"
                />
            )}
            <TriangleIcon
                className="h-[0.92rem] w-[1.0625rem] rotate-90"
                aria-hidden="true"
            />
            <div className="flex flex-col items-center gap-[0.8125rem]">
                <p className="m-0 rotate-180 font-sans text-[1.25rem] leading-[1.625rem] tracking-[0.025rem] whitespace-nowrap text-[#1f1f21] [writing-mode:vertical-rl]">
                    {displayName}
                </p>
                {/* The design's #898989 only reaches 3.5:1 on white; #767676 is
                    the darkest grey that still reads as a muted label at the
                    4.5:1 body-text threshold (WCAG AA). */}
                <p className="m-0 rotate-180 font-sans text-[1rem] leading-[1.25rem] whitespace-nowrap text-[#767676] [writing-mode:vertical-rl]">
                    Written by
                </p>
            </div>
        </aside>
    );
};
